<template>
  <button
    :class="['onx-sso-button', `sso-${color}`]"
    aria-label="Login with on X"
  >
    <div class="logo">
      <x-logo :color="logoColor" :hide-app-name="true" />
    </div>
    <div class="text">{{ text }}</div>
  </button>
</template>

<!-- eslint-disable vue/block-lang -->
<script setup>
import xLogo from '@/components/shared/x-logo'
import { computed } from 'vue'
import { DARK, LIGHT } from '@/components/x-onx-sso-button/constants'

const props = defineProps({
  color: {
    type: String,
    default: DARK,
    validator: (value) => [DARK, LIGHT].includes(value),
  },
  text: {
    type: String,
    default: 'Continue with onX',
  },
})

const logoColor = computed(() => (props.color === DARK ? LIGHT : DARK))
</script>

<style lang="scss" scoped>
@use '@/styles/system/_colors.scss';
@use '@/styles/system/_type.scss';
@use '@/styles/system/_variables.scss';
.onx-sso-button {
  @include type.button1Type;
  line-height: 0px;
  height: 48px;
  width: 100%;
  display: grid;
  grid-template-columns: 90px 1fr;
  border: 1px solid;
  padding: 0;
  border-radius: variables.$border-radius-lg;
  cursor: pointer;
  text-align: left;

  &.sso-dark {
    border-color: colors.$Grey90;
    color: colors.$BaseWhite;
    background-color: colors.$BaseBlack;

    &:hover {
      background-color: colors.$Grey100;
    }

    .logo {
      border-right-color: colors.$Grey90;
    }
  }

  &.sso-light {
    border-color: colors.$Grey30;
    color: colors.$Grey100;
    background-color: colors.$BaseWhite;

    &:hover {
      background-color: colors.$Grey20;
    }

    .logo {
      border-right-color: colors.$Grey30;
    }
  }
}

.logo,
.text {
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  height: 100%;
  display: grid;
  align-items: center;
}

.logo {
  border-right: 1px solid;
}
</style>
